import { Route, Routes } from 'react-router-dom';

import Index from '../pages';
import Appointment from '../pages/appointment';
import Create from '../pages/appointment/create';

export function Appointments() {
  return (
    <Routes>
      <Route path='/' element={<Index child={<Appointment />}/>} />
      <Route path='/create' element={<Index child={<Create />} />} />
    </Routes>
  );
}
